import { render } from "./InstallWizardCard.vue?vue&type=template&id=8d8283ba"
import script from "./InstallWizardCard.vue?vue&type=script&lang=js"
export * from "./InstallWizardCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__